export default [
    {
      reducerKey: 'user/accounts',
      sagaKey: 'userAccountsSaga',
      importReducer: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Accounts/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Accounts/store/saga'),
    },
    {
      reducerKey: 'user/profile',
      sagaKey: 'userProfileSaga',
      importReducer: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Profile/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Profile/store/saga'),
    },
    {
      reducerKey: 'user/2fa',
      sagaKey: 'user2faSaga',
      importReducer: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Security/2fa/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Security/2fa/store/saga'),
    },
    {
      sagaKey: 'userPasswordSaga',
      importSaga: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Security/Password/store/saga'),
    },
    {
      reducerKey: 'countries',
      sagaKey: 'countriesSaga',
      routeKeys: ['user/settings'],
      importReducer: () => import(/* webpackChunkName: "domain-user" */ 'modules/Countries/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-user" */ 'modules/Countries/store/saga'),
    },
]
